
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parts/inventory/[code]",
      function () {
        return require("private-next-pages/parts/inventory/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parts/inventory/[code]"])
      });
    }
  